export function notificationsDerivation() {
  const hasData = !!this.notifications.data.length;

  return !hasData ? { visible: false } : {
    visible: true,
    data: this.notifications.data.map((n) => n.content),
  };
}
